import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TemperatureHumidityService } from './temperature-humidity.service';

const SERVICES = [TemperatureHumidityService];

@NgModule({
    imports: [CommonModule],
    providers: [...SERVICES],
})
export class MockDataModule {
    static forRoot(): ModuleWithProviders<MockDataModule> {
        return {
            ngModule: MockDataModule,
            providers: [...SERVICES],
        };
    }
}
